<template lang="pug">
.userApprove
  van-field(
    v-model='approve.comment',
    rows='2',
    autosize,
    label='审批意见:',
    type='textarea',
    maxlength='200',
    placeholder='请输入意见',
    show-word-limit,
    v-if='showDefaultForm'
  )
  component(
    :is='userSelectDlg',
    ref='userSelectDlg',
    :custom-com-params='customComParams',
    @userSelected='afterUserSelected'
  )
  .approveButton
    //- van-button(type='info', @click='transfer') 转交
    van-button(type='primary', @click='agree') 同意
    van-button(type='danger', @click='rejectNodeFlow') 驳回
</template>
<script>
import personChoose from "@/CommonDP/pages/components/launchFlow/components/personChoose";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { Dialog, Notify } from "vant";
import { uploadDataUrl, getToken } from "@/CommonDP/utils";
import { notBlank } from "@/CommonDP/utils/validate";
import { ApproveAction } from "@/CommonDP/enums/FlowConstants";
import { getUserSelectDlg } from "@/CommonDP/pages/components/launchFlow/flowFormRegister.js";

const APPROVE = () => ({
  comment: "", // 审批意见
  flowInstanceNodeId: "",
  transferId: "",
  fileIds: [],
  name: ""
});
export default {
  components: { personChoose },
  props: {
    enableUpload: {
      type: Boolean,
      default: false
    },
    // 要求返回 true/false 表示是否继续
    // 原型：bool fn() 或者 Promise fn(), 其中 Promise 的 resolve 要返回一个 bool
    beforeAgree: {
      type: Function,
      default: null
    },

    showDefaultForm: {
      type: Boolean,
      default: true
    },

    // 原型：Object fn(action, approve)
    // 其中 action 取三个值：agree, reject, transfer
    // 其中 approve 是现有的审批数据（非 null）
    queryApproveData: {
      type: Function,
      default: null
    },

    // 原型：int fn(action, approve) 或 Promise fn(), 其中 Promise 的 resolve 要返回一个 int
    // 其中 action 取三个值：agree, reject, transfer
    // 其中 approve 是现有的审批数据（非 null）
    // 返回 0 或空表示不验证，而由内部自己验证。1 表示验证通过，2表示不通过
    validateFn: {
      type: Function,
      default: null
    },
    // 自定义选人组件所需参数
    customComParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      floderData: [],
      isSubmit: false,
      flowKey: "",
      approve: APPROVE(),
      fileList: [],
      action: "",
      // 默认使用内部的选人组件
      userSelectDlg: "personChoose",
      headers: {
        Authorization: "Bearer " + getToken()
      }
    };
  },
  computed: {
    ...mapState({
      routerParams: (state) => state.projectMg.routerParams
    })
  },

  async mounted() {
    // console.log(com, 'com----');
    this.action = uploadDataUrl();
    this.flowKey = this.routerParams.flowKey;
    this.flowStatus = this.routerParams.flowStatus;
    this.approve.flowInstanceNodeId = this.routerParams.flowInstanceNodeId;
  },

  methods: {
    // 接口:设置审批参数
    setFormData(formJson) {
      this.approve.formJson = formJson;
    },
    // 同意
    async agree() {
      const success = await this.validateAgree();
      if (!success) {
        return;
      }
      if (this.beforeAgree) {
        const success = await this.beforeAgree();
        console.debug("用户取消了同意操作");
        if (!success) {
          return;
        }
      }
      Dialog.confirm({
        message: '确定同意吗'
      })
        .then(() => {
          this.doAgree();
        })
        .catch(() => {
          // on cancel
        });
    },

    async doAgree() {
      this.getFormData();
      let json = this.approve;
      if (this.queryApproveData) {
        json = this.queryApproveData(ApproveAction.AGREE, this.approve);
      }
      const res = await flowService.agree(json);
      if (res.data && res.data.code && res.data.code === "E.FLOW.0005") {
        this.selectApplicant(res.data || {});
      } else {
        Notify({ type: "success", message: "操作成功" });
        this.$emit("afterAgree");
      }
    },
    // 接口：为特定节点设置处理人
    async selectApplicant(respData) {
      await this.$confirm("要继续，需要对节点：" + respData.nodeName + " 设置处理人，继续吗？");
      const com = getUserSelectDlg();
      if (com) {
        this.userSelectDlg = com;
      }
      console.log(com, 'com-----------');
      this.$nextTick(() => {
        this.$refs.userSelectDlg.show("设置节点 " + respData.nodeName + " 的处理人", { nodeDefinitionId: respData.nodeDefinitionId });
      });
    },

    async validateAgree() {
      if (this.validateFn) {
        const ret = await this.validateFn("agree", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      // 默认的校验，同意不需要更多的校验
      return true;
    },

    getFormData() {
      this.$emit("getFormData");
    },

    // 驳回
    async rejectNodeFlow() {
      const success = await this.validateReject();
      if (!success) {
        return;
      }
      Dialog.confirm({
        message: '确定驳回吗'
      })
        .then(async () => {
          let json = this.approve;
          if (this.queryApproveData) {
            json = this.queryApproveData(ApproveAction.REJECT, this.approve);
          }
          await flowService.rejectNodeFlow(json);
          Notify({ type: "success", message: "操作成功" });
          this.$emit("afterReject");
        })
        .catch(() => {
          // on cancel
        });
    },
    async validateReject() {
      if (this.validateFn) {
        const ret = await this.validateFn("reject", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      const success = notBlank(this.approve.comment, "驳回意见不能为空");
      return success;
    },

    // 转交
    async transfer() {
      const success = await this.validateTransfer();
      if (!success) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.userSelectDlg.show("选择转交人", { type: 0, transfer: "transfer" });
      });
    },
    async validateTransfer() {
      if (this.validateFn) {
        const ret = await this.validateFn("transfer", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      return true;
    },

    async afterUserSelected(users, type, params) {
      if (params && params.nodeDefinitionId) {
        // 指定的节点（一般是下一个节点）
        this.addSpecifiedNodeApproveUser(users, params.nodeDefinitionId);
      } else {
        // 当前节点, 转交操作
        this.approve.name = users[0].name;
        this.approve.transferId = users[0].userId;
        await flowService.transfer(this.approve);
        this.$emit("afterTransfer");
        Notify({ type: "success", message: "转交成功" });
      }
    },

    // 为特定的节点设置节点审批人
    addSpecifiedNodeApproveUser(userList, nodeDefinitionId) {
      if (!userList || !userList.length) {
        this.$error("没有选择任何人");
        return;
      }
      if (!nodeDefinitionId) {
        this.$error("参数错误，无节点信息");
        return;
      }
      console.debug("为节点：", nodeDefinitionId, "设置审批人：", userList);
      this.approve.nextNodeAssignee = { flowNodeDefinitionId: nodeDefinitionId, userDtoList: userList };
      this.doAgree();
    }
  }
};
</script>
  <style lang="scss" scoped>
.userApprove {
  display: flex;
  flex-direction: column;
}
.approveButton {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .van-button {
    height: 30px;
    padding: 5px 12px;
  }
}
</style>
